import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action, className = '' }) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center ${className}`}>
      {icon && <div className="mb-4 text-text-placeholder">{icon}</div>}
      {title && <h3 className="text-lg font-semibold text-text-primary mb-2">{title}</h3>}
      {description && <p className="text-sm text-text-secondary mb-4">{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
};
